// input-security: verified — fields: roster-toolbar-card__input

import React, { useRef } from 'react';
import { sanitizeSearchInput } from '../../utils/sanitizeUserTextInput';

function IconSearchRoster({ className }) {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.65" />
      <path d="M16 16l4.25 4.25" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" />
    </svg>
  );
}

function IconResetRoster({ className }) {
  return (
    <svg className={className} width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M4 12a8 8 0 0113.657-5.657" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 4H5v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 12a8 8 0 01-13.657 5.657" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M15 20h4v-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function HubToolbarSearch({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  autoComplete = 'off',
  resourceKey,
  action = 'read',
  description,
  route,
  className = '',
}) {
  const inputRef = useRef(null);

  const handleReset = () => {
    onChange('');
    inputRef.current?.focus();
  };

  return (
    <div
      className={[
        'roster-toolbar-card',
        'roster-toolbar-card--search',
        'hub-toolbar-search',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="roster-toolbar-card__search">
        <IconSearchRoster className="roster-toolbar-card__search-glyph" />
        <input
          ref={inputRef}
          id={id}
          className="roster-toolbar-card__input"
          type="search"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(sanitizeSearchInput(event.target.value))}
          disabled={disabled}
          autoComplete={autoComplete}
          data-resource={resourceKey}
          data-action={action}
          data-description={description}
          {...(route ? { 'data-route': route } : {})}
        />
      </div>

      <button
        type="button"
        className="roster-toolbar-card__reset"
        onClick={handleReset}
        disabled={disabled}
      >
        <IconResetRoster className="roster-toolbar-card__reset-glyph" />
        Reset
      </button>
    </div>
  );
}
